import gql from 'graphql-tag';

import type { BlogPostBuilderBrief } from 'src/data/blog';
import type { AllInstructionsData } from 'src/data/generation';
import type { UrlExtraction } from 'src/data/types';
import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type { BackendMutationUpdateBlogPostBuilderDescriptionArgs } from 'src/types/backend';

import { FRAGMENT_BLOG_POST_BUILDER_BRIEF } from './schema';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderDescription(
    $id: ID!
    $description: String!
    $urlExtractions: [UrlExtractionInput!]
    $freestyleToolAllInstructionsData: JSON
  ) {
    updateBlogPostBuilderDescription(
      id: $id
      description: $description
      urlExtractions: $urlExtractions
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
    ) {
      ...BlogPostBuilderBrief
    }
  }
  ${FRAGMENT_BLOG_POST_BUILDER_BRIEF}
`;

type Variables = Override<
  BackendMutationUpdateBlogPostBuilderDescriptionArgs,
  {
    urlExtractions?: UrlExtraction[];
    freestyleToolAllInstructionsData?: AllInstructionsData;
  }
>;

export const updateBlogPostBuilderDescription = async (
  variables: Variables
): Promise<BlogPostBuilderBrief | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      freestyleToolAllInstructionsData: stringifyIfPresent(
        variables.freestyleToolAllInstructionsData
      ),
    },
  });

  return getSingleProp<BlogPostBuilderBrief>(result.data);
};
